import {
  LoginFormData as _LoginFormData,
  PointsOnOrderDeliveryFormData as _PointsOnOrderDeliveryFormData,
  WelcomeFormData as _WelcomeFormData,
  PayByPointsOnOrderDeliveryFormData as _PayByPointsOnOrderDeliveryFormData,
  FormErrors as _FormErrors,
  ACTIVITY_TYPES as _ACTIVITY_TYPES,
  activityOptions as _activityOptions,
  orderTypeOptions as _orderTypeOptions,
  OrderType as _OrderType,
  ACTIVITY_TYPES_ENUM as _ACTIVITY_TYPES_ENUM,
  ACTIVITY_TYPE as _ACTIVITY_TYPE,
  ACTIVITY_TYPE_TO_VALUE as _ACTIVITY_TYPE_TO_VALUE,
  WARNING_MESSAGE as _WARNING_MESSAGE,
  isVideoActivityType as _isVideoActivityType
} from '@/utils/constants/activityConstants';

// Interface for Login Activity Form Data
export const LoginFormData = _LoginFormData;

// Interface for Points On Order Delivery Activity Form Data
export const PointsOnOrderDeliveryFormData = _PointsOnOrderDeliveryFormData;

// Interface for Welcome Activity Form Data
export const WelcomeFormData = _WelcomeFormData;

// Interface for Pay by Points on Order Delivery Activity Form Data
export const PayByPointsOnOrderDeliveryFormData =
  _PayByPointsOnOrderDeliveryFormData;

export const FormErrors = _FormErrors;

export const ACTIVITY_TYPES = _ACTIVITY_TYPES;

export const activityOptions = _activityOptions;

export const orderTypeOptions = _orderTypeOptions;

export const OrderType = _OrderType;

export const ACTIVITY_TYPES_ENUM = _ACTIVITY_TYPES_ENUM;

export const ACTIVITY_TYPE = _ACTIVITY_TYPE;

export const ACTIVITY_TYPE_TO_VALUE = _ACTIVITY_TYPE_TO_VALUE;

export const WARNING_MESSAGE = _WARNING_MESSAGE;

export const isVideoActivityType = _isVideoActivityType;
